import { useQuery } from '@tanstack/react-query';
import type { ListEquipmentLabelsResponse } from 'shared';
import { api } from '@/lib/api';

/**
 * The stickers of a centre's equipment (or of every centre's, with no centre
 * given): each one's name and its code drawn for print.
 */
export function useEquipmentLabels(digitalCenterID: number | null) {
  const qs = new URLSearchParams(
    digitalCenterID ? { digitalCenterID: String(digitalCenterID) } : {},
  );
  return useQuery({
    queryKey: ['equipments', 'labels', digitalCenterID],
    queryFn: () => api.get<ListEquipmentLabelsResponse>(`/api/equipments/labels?${qs}`),
    staleTime: 1000 * 60,
  });
}
